/* eslint-disable no-shadow */
/* eslint-disable no-console */

import ReportCostsAPI from '../../api/reportCosts';
import types from '../mutation-types';

export const state = {
  costs: [],
  meta: {
    count: 0,
    current_page: 1,
    page_size: 25,
  },
  uiFlags: {
    isFetching: false,
  },
};

// list of getters
const getters = {
  getReportCostUIFlags(_state) {
    return _state.uiFlags;
  },
  getReportCostMeta(_state) {
    return _state.meta;
  },
  getReportCosts(_state) {
    return _state.costs;
  },
  getReportCostsTotal(_state) {
    return _state.costs.reduce(
      (sum, record) => sum + (record.total_cost || 0),
      0
    );
  },
};

// actions list
const actions = {
  fetchReportCosts: async ({ commit, state }, query) => {
    commit(types.SET_REPORT_COSTS_UI_FLAG, { isFetching: true });
    try {
      const response = await ReportCostsAPI.getCostList(query);
      const newData = response.data?.data || [];
      const meta = {
        ...state.meta,
        ...(response.data?.meta || {}),
      };
      commit(types.SET_REPORT_COSTS, newData);
      commit(types.SET_REPORT_COSTS_META, meta);
      commit(types.SET_REPORT_COSTS_UI_FLAG, { isFetching: false });
    } catch (error) {
      console.error('Error fetching report costs:', error);
      commit(types.SET_REPORT_COSTS_UI_FLAG, { isFetching: false });
    }
  },
  filterReportCosts: async ({ commit, state }, query) => {
    commit(types.SET_REPORT_COSTS_UI_FLAG, { isFetching: true });
    try {
      const { payload, ...restParams } = query;
      const response = await ReportCostsAPI.getCostList({
        ...restParams,
        payload: payload,
      });
      const newData = response.data?.data || [];
      const meta = {
        ...state.meta,
        ...(response.data?.meta || {}),
      };
      commit(types.SET_REPORT_COSTS, newData);
      commit(types.SET_REPORT_COSTS_META, meta);
      commit(types.SET_REPORT_COSTS_UI_FLAG, { isFetching: false });
    } catch (error) {
      console.error('Error filtering report costs:', error);
      commit(types.SET_REPORT_COSTS_UI_FLAG, { isFetching: false });
    }
  },
};

// list of mutations
const mutations = {
  [types.SET_REPORT_COSTS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_REPORT_COSTS]($state, data) {
    $state.costs = data;
  },
  [types.SET_REPORT_COSTS_META]($state, meta) {
    $state.meta = {
      ...meta,
      count: meta.count || 0,
      current_page: meta.current_page || 1,
      page_size: meta.page_size || 15,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
